import type { SubscriptionItem } from '@/_shared/middleware/individual/subscriptionMiddleware';

// First value is this feature's; more alert types land here as other
// features adopt the generic `alerts` table.
export enum AlertType {
  _ds_alert = 'ds_alert',
}

export interface AlertRow {
  id: string;
  organizationId: number;
  module: SubscriptionItem;
  alertType: AlertType;
  alertDate: string;
  metadata: Record<string, unknown> | null;
  createdAt: Date;
}

/** AlertRow plus this user's read state — the navbar notification list's row shape. */
export interface AlertListItem extends AlertRow {
  isRead: boolean;
}
